import { Card, Typography } from 'antd';

import React, { FC, useEffect, useMemo, useState } from 'react';
import { transportMovements } from '@/api/TransportMovements';
import { LoadLogEntry, VehicleLogEntry } from '@/types';
import { useTranslate } from '@/translations';
import { CustomColumns, CustomTable } from '@/ui/components';
import { timeConverter } from '@/utils/helpers';
import { FORMAT_FULL_TIME_DAYJS } from '@/utils/constants';
import { TransportMovementLogsProps } from './types';
// VehicleLogEntry,

export const TransportMovementLogs: FC<TransportMovementLogsProps> = ({
  loadId,
  loadNumber,
}) =>
  // (
  {
    const [loadLogs, setLoadLogs] = useState<LoadLogEntry[]>([]);
    const [vehicleLogs, setVehicleLogs] = useState<VehicleLogEntry[]>([]);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslate();

    useEffect(() => {
      const fetchMovementsLogs = async () => {
        try {
          setLoading(true);
          const response = await transportMovements.getMovementsLogs(
            loadId || 0,
          );
          const data = response.data?.entities;

          setLoadLogs(data?.loadLogs ?? []);
          setVehicleLogs(data?.vehicleLogs ?? []);
        } catch (error) {
          console.error('Failed to fetch logs:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchMovementsLogs();
    }, [loadId]);

    const LoadLogsColumns: CustomColumns<LoadLogEntry> = useMemo(
      () => [
        {
          dataIndex: 'transType',
          title: t('transactionType'),

          filter: true,
          ellipsis: true,
        },
        {
          dataIndex: 'transDescription',
          title: t('transactionDescription'),

          sortable: true,
          filter: true,
          ellipsis: true,
        },
        {
          dataIndex: 'transDate',
          title: t('transactionDate'),
          sortable: true,
          filter: true,
          ellipsis: true,
          render: (value) => timeConverter(value, FORMAT_FULL_TIME_DAYJS),
        },
      ],
      [t],
    );

    const vehicleLogsColumns: CustomColumns<VehicleLogEntry> = useMemo(
      () => [
        {
          dataIndex: 'serialNumber',
          title: t('vin'),
          sortable: true,
          filter: true,
          ellipsis: true,
        },
        {
          dataIndex: 'transType',
          title: t('transactionType'),

          filter: true,
          ellipsis: true,
        },
        {
          dataIndex: 'transDescription',
          title: t('transactionDescription'),

          sortable: true,
          filter: true,
          ellipsis: true,
        },
        {
          dataIndex: 'transDate',
          title: t('transactionDate'),
          sortable: true,
          filter: true,
          ellipsis: true,
          render: (value) => timeConverter(value, FORMAT_FULL_TIME_DAYJS),
        },
      ],
      [t],
    );
    return (
      <>
        <Card>
          <Typography.Title level={5}>
            {t('load')} {loadNumber} {t('logs')}
          </Typography.Title>
          <CustomTable
            dataSource={loadLogs || []}
            columns={LoadLogsColumns}
            loading={loading}
            rowKey="movementId"
            pagination={{ showSizeChanger: true }}
          />
        </Card>
        <Card style={{ margin: '15px 0' }}>
          <Typography.Title level={5}>
            {t('load')} {loadNumber} {t('vehicle')} {t('logs')}
          </Typography.Title>
          <CustomTable
            dataSource={vehicleLogs || []}
            columns={vehicleLogsColumns}
            loading={loading}
            rowKey="movementId"
            pagination={{ showSizeChanger: true }}
            rowClassName={(record) =>
              record.transType?.toLowerCase() === 'vin remove'
                ? 'vin-removed-row'
                : record.transType?.toLowerCase() === 'vin added'
                  ? 'vin-added-row'
                  : ''
            }
          />
        </Card>
      </>
    );

    // );
  };
